export enum ReconcileReasonType {
    OverageKept = 1,
    OverageRefused = 2,
    Shortage = 3,
    Damaged = 4,
    Destroyed = 5,
    Return = 6,
    ReturnHold = 7,
    EditedCatchWeight = 8,
    ProductTemp = 9,
    ShelfLife = 10
}

export enum ReasonClass {
    Overage = "Overage",
    Shortage = "Shortage",
    Even = "Even",
    Refused = "Refused"
}